import React, { useState } from 'react';
import Header from "../../components/Header";
import GerencimentoQuestionario from '../../components/Questionarios/GerenciamentoQuestionario';
import { Context } from "../../AppProvider";
import { useLocation } from "react-router-dom";
import "./styles.css"

function TelaGerenciamentoQuestionario(props) {
  const {state} = useLocation();

  const [questionario, setQuestionario] = useState(state.questionario);

  return (
      <Context.Consumer>
      {(context) => (
        <div>
          <Header usuario={context.usuario} videoajuda={props.videoajuda} />
          <GerencimentoQuestionario questionario={questionario} setQuestionario={setQuestionario} />
        </div>
      )}
    </Context.Consumer>
  )
}

export default TelaGerenciamentoQuestionario;